import styled from 'styled-components'

export const Hr = styled.div`
  background-color: #E8E8E8;
  height: 2px;
  margin: 0 auto;
  margin-top: 16px;
  margin-bottom: 16px;
  width: ${props => (props.width ? props.width : 100)}%;
`



// WEBPACK FOOTER //
// ./src/styled/hr.js